import { render, staticRenderFns } from "./know.vue?vue&type=template&id=15e828aa&scoped=true"
import script from "./know.vue?vue&type=script&lang=js"
export * from "./know.vue?vue&type=script&lang=js"
import style0 from "./know.vue?vue&type=style&index=0&id=15e828aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e828aa",
  null
  
)

export default component.exports